import {
    Create,
    TextInput,
    required,
    SimpleForm,
    DateTimeInput,
    NullableBooleanInput,
    SelectInput,
    FormDataConsumer,
    minValue,
    NumberInput,
} from 'react-admin';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';
import { ECOM_COUPON_TYPE } from '../../common/constants';
import { EcomCategoriesAutoComplete } from '../../common/inputs/autoCompleteInputs/EcomCategoriesAutoComplete';
import { EcomProductTemplateAutoComplete } from '../../common/inputs/autoCompleteInputs/EcomProductTemplateAutoComplete';

export const studentProfileRender = (choice: any) => `${choice.name}` || '';

export const filterToQueryStudent = (searchText: string) => ({
    name: `${searchText}%`,
});
const CouponCreate = () => {
    return (
        <Create redirect={'/ecom-coupons'}>
            <SimpleForm>
                <TextInput source="code" fullWidth validate={[required()]} />
                <SelectInput
                    source="type"
                    label="Type"
                    fullWidth
                    validate={[required()]}
                    choices={ECOM_COUPON_TYPE}
                />
                <FormDataConsumer>
                    {({ formData, ...rest }) =>
                        formData.type === 'PERCENTAGE' ? (
                            <>
                                <NumberInput
                                    source="discountInPercentage"
                                    prefix={'%'}
                                    fullWidth
                                    validate={[ required(),minValue(0)]}
                                />

                                <NumberInput
                                    source="maxDiscountPrice"
                                    prefix={'₹'}
                                    type={'number'}
                                    validate={[minValue(0)]}
                                    fullWidth
                                />
                            </>
                        ) : (
                            <NumberInput
                                source="discountInPrice"
                                prefix={'₹'}
                                type={'number'}
                                validate={[minValue(0), required()]}
                                fullWidth
                            />
                        )
                    }
                </FormDataConsumer>
                <NumberInput source="maxTotalUsages" type={'number'} fullWidth validate={[minValue(0),required()]}/>
                <NumberInput source="maxUsageByPerStudent" type={'number'} fullWidth  validate={[required() ,minValue(0)]} />
                <EcomCategoriesAutoComplete label="Ecom Category" />
                <EcomProductTemplateAutoComplete label="Ecom Product Template" />
                <NullableBooleanInput source={'hidden'} fullWidth />
                <DateTimeInput source={'startedAt'} validate={[required()]} fullWidth />
                <DateTimeInput source={'expiringAt'} fullWidth validate={[required()]} />
                <HTMLEditorInput
                    source={'description'}
                    fullWidth
                    validate={[required(), validHtml]}
                />
            </SimpleForm>
        </Create>
    );
};

export default CouponCreate;
